document.addEventListener("DOMContentLoaded", () => {

    console.log("Bundle JS Loaded");

    const bundle = document.querySelector(".bundle-selector");

    if (!bundle) return;

    console.log("Bundle selector found");

    const checkboxes = bundle.querySelectorAll(".bundle-checkbox");
    const hiddenInput = document.getElementById("bundle-items-input");

    const maxSelection = parseInt(bundle.dataset.maxSelection, 10) || 0;
    const max1000 = parseInt(bundle.dataset["max-1000"], 10) || 0;
    const max500 = parseInt(bundle.dataset["max-500"], 10) || 0;
    const max250 = parseInt(bundle.dataset["max-250"], 10) || 0;

    console.log({
        maxSelection,
        max1000,
        max500,
        max250
    });


    /*
     * TAB SYSTEM
     */

    const tabs = bundle.querySelectorAll(".bundle-tab");
    const panels = bundle.querySelectorAll(".bundle-tab-panel");

    function activateTab(target) {

        tabs.forEach(tab => {
            const isActive = tab.dataset.tab === target;

            tab.classList.toggle("active", isActive);
            tab.setAttribute("aria-selected", isActive ? "true" : "false");
        });

        panels.forEach(panel => {
            panel.classList.toggle(
                "active",
                panel.dataset.panel === target
            );
        });

    }

    tabs.forEach(tab => {

        tab.addEventListener("click", () => {
            activateTab(tab.dataset.tab);
        });

    });

    // Open the first available tab
    if (tabs.length > 0) {
        activateTab(tabs[0].dataset.tab);
    }


    /*
     * STATUS ELEMENTS
     */

    const totalStatus = document.getElementById("bundle-total-status");
    const status1000 = document.getElementById("bundle-1000-status");
    const status500 = document.getElementById("bundle-500-status");
    const status250 = document.getElementById("bundle-250-status");


    /*
     * STATUS UPDATE
     */

    function updateStatus(element, current, limit) {

        if (!element) return;

        element.textContent = `${current} / ${limit}`;

        element.classList.remove(
            "bundle-success",
            "bundle-warning",
            "bundle-danger"
        );

        if (current >= limit) {
            element.classList.add("bundle-danger");
        }
        else if (current === limit - 1) {
            element.classList.add("bundle-warning");
        }
        else {
            element.classList.add("bundle-success");
        }

    }


    /*
     * SELECTION
     */

    function updateSelection() {

        const selected = [];

        let count1000 = 0;
        let count500 = 0;
        let count250 = 0;

        checkboxes.forEach(box => {

            if (!box.checked) return;

            const grams = parseInt(box.dataset.grams, 10);

            selected.push(
                `${box.value} (${grams}g)`
            );

            switch (grams) {

                case 1000:
                    count1000++;
                    break;

                case 500:
                    count500++;
                    break;

                case 250:
                    count250++;
                    break;

            }

        });


        /*
         * SAVE SELECTED ITEMS
         */

        if (hiddenInput) {
            hiddenInput.value = selected.join(", ");
        }


        /*
         * DEBUG
         */

        console.log({
            total: selected.length,
            "1000g": count1000,
            "500g": count500,
            "250g": count250
        });


        /*
         * UPDATE STATUS
         */

        updateStatus(
            totalStatus,
            selected.length,
            maxSelection
        );

        if (max1000 > 0) {
            updateStatus(
                status1000,
                count1000,
                max1000
            );
        }

        if (max500 > 0) {
            updateStatus(
                status500,
                count500,
                max500
            );
        }

        if (max250 > 0) {
            updateStatus(
                status250,
                count250,
                max250
            );
        }


        /*
         * ENABLE / DISABLE OPTIONS
         */

        checkboxes.forEach(box => {

            // Always keep already-selected items enabled
            // so the customer can unselect them.
            if (box.checked) {
                box.disabled = false;
                return;
            }

            const grams = parseInt(box.dataset.grams, 10);

            const panel = box.closest(".bundle-tab-panel");

            const mode = panel
                ? panel.dataset.bundleMode
                : "weighted";

            let disable = false;


            /*
             * GLOBAL MAXIMUM SELECTION
             *
             * Applies to BOTH:
             *
             * 1. Weighted bundles
             * 2. Any-g bundles
             */

            if (selected.length >= maxSelection) {
                disable = true;
            }


            /*
             * WEIGHT-SPECIFIC LIMITS
             *
             * ONLY apply to the normal
             * 250g / 500g / 1000g tabs.
             *
             * They DO NOT apply to Any-g.
             */

            if (mode === "weighted") {

                if (
                    grams === 1000 &&
                    max1000 > 0 &&
                    count1000 >= max1000
                ) {
                    disable = true;
                }

                if (
                    grams === 500 &&
                    max500 > 0 &&
                    count500 >= max500
                ) {
                    disable = true;
                }

                if (
                    grams === 250 &&
                    max250 > 0 &&
                    count250 >= max250
                ) {
                    disable = true;
                }

            }


            box.disabled = disable;

        });

    }


    /*
     * CHECKBOX EVENTS
     */

    checkboxes.forEach(box => {

        box.addEventListener(
            "change",
            updateSelection
        );

    });


    /*
     * INITIAL STATE
     */

    updateSelection();

});